

























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Course as ICourse } from "@/api-v2/course/models/course";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import { LearningUnit as ILearningUnit } from "@/api-v2/course/models/learning-unit";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { courseApi, scormApi } from "@/getinfo-api";
import { createScorm2004, createScorm12 } from "@/getinfo-api/scormApi";
import { getCurrentUserId } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({ components: { CustomButton, CPage } })
export default class ScormView extends Vue {
  @Prop() course!: ICourse;
  @Prop() courseRegistration!: IRegistration;
  @Prop() learningUnit!: ILearningUnit;
  url!: string;
  sessionId!: string;
  version!: string;
  canMoveOn: boolean = false;

  data() {
    return {
      url: undefined,
      sessionId: undefined,
      version: undefined
    };
  }

  get userId() {
    return getCurrentUserId();
  }

  @Watch("canMoveOn")
  changeCanMoveOn() {
    this.$emit("moveOn", this.canMoveOn);
  }

  requestFullScreen() {
    let iframe = document.getElementById("iframe");
    if (iframe) {
      iframe.requestFullscreen();
    }
  }

  getLearningProgress() {
    courseApi.LearningProgress.getLearningProgress(this.courseRegistration.id)
      .then(res => {
        let index = res.data.learningUnits.findIndex(
          el => el.iri === this.learningUnit.iri
        );
        this.canMoveOn = res.data.learningUnits[index].canMoveOn;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async created() {
    this.getLearningProgress();
    scormApi.ScormLearningProgress.launchScorm(
      this.$route.params.courseId,
      this.$route.params.id
    )
      .then(res => {
        this.sessionId = res.data.sessionId;
        this.version = res.data.version;

        scormApi.ScormLearningProgress.initializeScorm(
          this.$route.params.courseId,
          this.$route.params.id,
          {
            sessionId: this.sessionId
          }
        )
          .then(() => {
            if (this.version === "scorm_1.2") {
              this.url = res.data.url;
              window.API = createScorm12(
                this.$route.params.courseId,
                this.sessionId,
                this.$route.params.id,
                true,
                this.getLearningProgress
              );
            } else {
              this.url = res.data.url;
              window.API_1484_11 = createScorm2004(
                this.$route.params.courseId,
                this.sessionId,
                this.$route.params.id,
                true,
                this.getLearningProgress
              );
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  terminateSession() {
    scormApi.ScormLearningProgress.finishScorm(
      this.course.id,
      this.learningUnit.id,
      {
        sessionId: this.sessionId
      }
    );
  }

  beforeDestroy() {
    this.terminateSession();
    delete window.API_1484_11;
    delete window.API;
  }
}
